import { type CreativeModelFactoryConfig } from '@bynder-studio/render-web';
import { type FontFamily } from '@bynder-studio/structured-text';
import { gatewayClient, createService } from './connectors/httpClient';

export type CreativeTemplate = Pick<CreativeModelFactoryConfig, 'template' | 'textStyles' | 'contentProperties'> & {
    galleryFonts: FontFamily[];
    defaultRenditionProfileId?: number | null;
    _template?: unknown;
    variationSetsValues?: unknown[];
};

const httpClient = gatewayClient('/creatives');

const creativeEditorService = createService(httpClient, (client) => ({
    getCreativeTemplate(creativeId: number, lastPublish: boolean) {
        return client.get<CreativeTemplate>(`/v2/${creativeId}/editor?lastPublish=${lastPublish}`);
    },

    discardCreativeTemplate(creativeId: number) {
        return client.delete(`/v2/${creativeId}`).then(({ json, status }) => {
            return { status, json };
        });
    },
}));

export default creativeEditorService;
